/**
 * 공유 폴더 어노테이션 표시 여부를 localStorage에 저장/로드하는 유틸리티
 */

const STORAGE_KEY_PREFIX = 'shared_folder_annotation_visibility_';

/**
 * 공유 폴더 어노테이션 표시 여부를 localStorage에 저장
 * @param folderUuid 공유 폴더 UUID
 * @param isVisible 표시 여부 (true: 표시, false: 숨김)
 */
export const setSharedFolderAnnotationVisibility = (folderUuid: string, isVisible: boolean): void => {
  try {
    const key = `${STORAGE_KEY_PREFIX}${folderUuid}`;
    localStorage.setItem(key, JSON.stringify(isVisible));
  } catch (error) {
    // console.error('[공유 폴더 어노테이션 저장 오류]:', error);
  }
};

/**
 * 공유 폴더 어노테이션 표시 여부를 localStorage에서 로드
 * @param folderUuid 공유 폴더 UUID
 * @returns 표시 여부 (기본값: true)
 */
export const getSharedFolderAnnotationVisibility = (folderUuid: string): boolean => {
  try {
    const key = `${STORAGE_KEY_PREFIX}${folderUuid}`;
    const stored = localStorage.getItem(key);
    if (stored === null) {
      // 기본값은 true (표시)
      return true;
    }
    return JSON.parse(stored) === true;
  } catch (error) {
    // console.error('[공유 폴더 어노테이션 로드 오류]:', error);
    // 오류 시 기본값 반환
    return true;
  }
};

/**
 * 모든 공유 폴더 어노테이션 표시 여부를 한 번에 가져오기
 * @param folderUuids 공유 폴더 UUID 배열
 * @returns 폴더 UUID를 키로 하는 Map
 */
export const getAllSharedFolderAnnotationVisibility = (folderUuids: string[]): Map<string, boolean> => {
  const visibilityMap = new Map<string, boolean>();
  folderUuids.forEach(uuid => {
    visibilityMap.set(uuid, getSharedFolderAnnotationVisibility(uuid));
  });
  return visibilityMap;
};
